<div class="modal-container">
  <div class="img-container">
    <img src="assets/images/money-bag.png" alt="" class="money-bag-img" />
  </div>
  <div class="modal-content">
    <h3 mat-dialog-title class="opt-in-heading">Exciting news!</h3>
    <p class="sub-text">
      With personalized offers, we can tell you your estimated loan amount up
      front. Opt in today.
    </p>

    <button class="opt-in-disclosure-btn" (click)="disclosureClick()">
      Credit profile authorization
    </button>
    <div class="btn-div">
      <button
        id="agree-button"
        class="agree-btn opt-in-btn"
        (click)="closeOptInModal(true)"
      >
        Agree
      </button>
      <button
        id="maybe-later-button"
        class="maybe-later-btn opt-in-btn"
        (click)="closeOptInModal(false)"
      >
        Maybe later
      </button>
    </div>
  </div>
</div>
